// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ed2zw","footer":"styles_footer__1eGm0","passCodeTooltip":"styles_passCodeTooltip__irrA7"};